/**
 * Module namespaced.
 */
export const namespaced = true;

/**
 * Module state.
 */
export const state = {
  list: [
    {
      id: 9,
      type: 'received',
      percent: 1.41,
      quantity: 0.0003,
    },
    {
      id: 8,
      type: 'sent',
      percent: -5.55,
      quantity: -0.0003,
    },
    {
      id: 7,
      type: 'received',
      percent: 2.53,
      quantity: 0.0003,
    },
    {
      id: 6,
      type: 'sent',
      percent: -5.55,
      quantity: -0.0003,
    },
    {
      id: 5,
      type: 'sent',
      percent: -5.55,
      quantity: -0.0003,
    },
    {
      id: 4,
      type: 'received',
      percent: 13.5,
      quantity: 0.0003,
    },
    {
      id: 3,
      type: 'received',
      percent: 0.31,
      quantity: 0.0003,
    },
    {
      id: 2,
      type: 'sent',
      percent: -5.55,
      quantity: -0.0003,
    },
    {
      id: 1,
      type: 'sent',
      percent: -5.55,
      quantity: -0.0003,
    },
    {
      id: 0,
      type: 'sent',
      percent: -5.55,
      quantity: -0.0003,
    },
  ],
};

/**
 * Module mutations.
 */
export const mutations = {
  ADD (state, account) {
    state.list.unshift({
      ...account,
      id: (state.list[0].id + 1),
      quantity: account.quantity * -1,
    });
  },
};
